"use client";
import * as React from "react";
const SvgChevronLeftSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 8 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7.7 1.41 6.3 0l-6 6 6 6 1.4-1.41L3.14 6z" }));
export {
  SvgChevronLeftSharp as default
};
